const pageNameKey = "autoTranslationButton";

export const autoTranslationButtonEn = {
  [pageNameKey]: {
    autoTranslationLabel: "Auto-translation",
    settingsUpdatedSuccessfully:
      "Successfully updated auto-translation setting for the ticket",
  },
};

export const autoTranslationButtonPtBr = {
  [pageNameKey]: {
    autoTranslationLabel: "Tradução automática",
    settingsUpdatedSuccessfully:
      "Configuração de tradução automática do ticket atualizada com sucesso",
  },
};

export const autoTranslationButtonDe = {
  [pageNameKey]: {
    autoTranslationLabel: "Automatische Übersetzung",
    settingsUpdatedSuccessfully:
      "Auto-Übersetzungseinstellung für das Ticket erfolgreich aktualisiert",
  },
};

export const autoTranslationButtonZhHans = {
  [pageNameKey]: {
    autoTranslationLabel: "自动翻译",
    settingsUpdatedSuccessfully: "成功更新了工单的自动翻译设置",
  },
};

export const autoTranslationButtonIt = {
  [pageNameKey]: {
    autoTranslationLabel: "Auto-traduzione",
    settingsUpdatedSuccessfully:
      "Impostazione di traduzione automatica per il ticket aggiornata con successo",
  },
};

export const autoTranslationButtonEs = {
  [pageNameKey]: {
    autoTranslationLabel: "Traducción automática",
    settingsUpdatedSuccessfully:
      "Se actualizó correctamente la configuración de traducción automática del ticket",
  },
};

export const autoTranslationButtonNl = {
  [pageNameKey]: {
    autoTranslationLabel: "Automatische vertaling",
    settingsUpdatedSuccessfully:
      "Instelling voor automatische vertaling van het ticket succesvol bijgewerkt",
  },
};

export const autoTranslationButtonTr = {
  [pageNameKey]: {
    autoTranslationLabel: "Otomatik çeviri",
    settingsUpdatedSuccessfully:
      "Bilet için otomatik çeviri ayarı başarıyla güncellendi",
  },
};
